import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../services/api";
import toast from "react-hot-toast";
import "../styles/ForgotPassword.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSubmitted(true);
      toast.success("Password reset email sent!");
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to send reset email",
      );
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="fp-auth-container">
        <h1>📧 Check Your Email</h1>
        <p>
          We've sent a password reset link to <strong>{email}</strong>
        </p>
        <div className="fp-auth-link">
          <Link to="/login">← Back to Login</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="fp-auth-container">
      <h1>Forgot Password</h1>
      <p>
        Enter your email address and we'll send you a link to reset your
        password.
      </p>
      <form className="fp-form" onSubmit={handleSubmit}>
        <div className="fp-form-group">
          <label>Email Address</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="you@example.com"
          />
        </div>
        <button type="submit" className="fp-btn-submit" disabled={loading}>
          {loading ? "Sending..." : "Send Reset Link →"}
        </button>
      </form>
      <div className="fp-auth-link">
        <Link to="/login">← Back to Login</Link>
      </div>
    </div>
  );
};

export default ForgotPassword;
